module.exports = __webpack_public_path__ + "img/point2_screen01.76e5cd69.jpg";